// Actions
export const BILLING_HISTORY__GET_ITEMS = 'BILLING_HISTORY__GET_ITEMS';
export const BILLING_HISTORY__UPDATE_ITEMS = 'BILLING_HISTORY__UPDATE_ITEMS';
// Mutations
export const BILLING_HISTORY__RESET = 'BILLING_HISTORY__RESET';
export const BILLING_HISTORY__MUTATE_ITEMS = 'BILLING_HISTORY__MUTATE_ITEMS';
export const BILLING_HISTORY__MUTATE_LOADING_STATUS = 'BILLING_HISTORY__MUTATE_LOADING_STATUS';
